import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

// Импортируй картинки так, как используешь
import '../assets/css/HomePage.css';
import {  app1, app2, app3 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}





// ---- SEO helpers ----
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href, extraAttrs = {}) {
  if (!href) return;
  // Ищем существующий <link rel="..." hreflang="...">
  let selector = `link[rel="${rel}"]`;
  if (extraAttrs.hreflang) selector += `[hreflang="${extraAttrs.hreflang}"]`;

  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);

    // 👉 сначала добавляем href, потом hreflang
    el.setAttribute("href", href);
    if (extraAttrs.hreflang) el.setAttribute("hreflang", extraAttrs.hreflang);

    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extraAttrs.hreflang) el.setAttribute("hreflang", extraAttrs.hreflang);
  }
}

function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}

function toAbsoluteUrl(possiblyRelative) {
  if (!possiblyRelative) return "";
  // Если импорт дал уже абсолютный URL — вернём как есть
  if (/^https?:\/\//i.test(possiblyRelative)) return possiblyRelative;
  // Для собранных ассетов Vite/CRA вернётся уже абсолютный пути. На всякий случай — префиксни origin.
  return `${window.location.origin}${possiblyRelative.startsWith("/") ? "" : "/"}${possiblyRelative}`;
}



const Application = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";


useEffect(() => {
  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // ===== Alternate URLs =====
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  // ===== Page copy =====
  const pageTitleEN = "  HHBD App — Download Android Casino & Betting App BD";
  const pageDescEN =
    "Download the HHBD App for Android and play anywhere in Bangladesh! Access slots, crash games, and sports betting with fast deposits, mobile bonuses & instant BDT withdrawals through bKash and Nagad.";

  const pageTitleBN = "HHBD অ্যাপ — অ্যান্ড্রয়েড ক্যাসিনো এবং বেটিং অ্যাপ BD ডাউনলোড করুন";
  const pageDescBN =
    "অ্যান্ড্রয়েডের জন্য HHBD অ্যাপ ডাউনলোড করুন এবং বাংলাদেশের যেকোনো জায়গায় খেলুন! বিকাশ এবং নগদের মাধ্যমে দ্রুত ডিপোজিট, মোবাইল বোনাস এবং তাৎক্ষণিক টাকা তোলার মাধ্যমে স্লট, ক্র্যাশ গেম এবং স্পোর্টস বেটিং অ্যাক্সেস করুন।";

  const pageKeywordsEN =
    "HHBD App, Android casino app BD, betting app Bangladesh, mobile casino BD, BDT payment app, download casino app";
  const pageKeywordsBN =
    "HHBD অ্যাপ, অ্যান্ড্রয়েড ক্যাসিনো অ্যাপ, বেটিং অ্যাপ বিডি, মোবাইল গেম বাংলাদেশ, পেমেন্ট অ্যাপ, ক্যাসিনো ডাউনলোড";

  const isBN = lang === "bn";
  const pageTitle = isBN ? pageTitleBN : pageTitleEN;
  const pageDesc = isBN ? pageDescBN : pageDescEN;
  const pageKeywords = isBN ? pageKeywordsBN : pageKeywordsEN;

  const ogImage = toAbsoluteUrl(app1);
  const twitterImageAlt = isBN
    ? "HHBD অ্যাপ ডাউনলোড করুন - নিরাপদ BDT পেমেন্টের মাধ্যমে আপনার ফোনে ক্যাসিনো, স্লট এবং লাইভ বেটিং অ্যাক্সেস করুন।"
    : "Download the HHBD App – access casino, slots and live betting on your phone with secure BDT payments.";

  // ===== BASIC META =====
  document.title = pageTitle.toUpperCase(); // ✅ only title uppercase
  setMetaName("description", pageDesc);
  setMetaName("keywords", pageKeywords);

  // ===== CANONICAL + HREFLANG =====
  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // ===== OPEN GRAPH =====
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle.toUpperCase()); // ✅ uppercase
  setMetaProperty("og:description", pageDesc);
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", twitterImageAlt);
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // ===== TWITTER META =====
  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle.toUpperCase()); // ✅ uppercase
  setMetaName("twitter:description", pageDesc);
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);


  
}, [lang, pathname]);



  return (
    <>
    
    <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = lang === "bn";
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/app";
      const siteName = "HHBD";

      // Page copy (same tone as visible content)
      const titleEN = " HHBD App — Download Android Casino & Betting App BD";
      const descEN =
        "Download the HHBD App for Android and play anywhere in Bangladesh! Access slots, crash games, and sports betting with fast deposits, mobile bonuses & instant BDT withdrawals through bKash and Nagad.";

      const titleBN = "HHBD অ্যাপ — অ্যান্ড্রয়েড ক্যাসিনো এবং বেটিং অ্যাপ BD ডাউনলোড করুন";
      const descBN =
        "অ্যান্ড্রয়েডের জন্য HHBD অ্যাপ ডাউনলোড করুন এবং বাংলাদেশের যেকোনো জায়গায় খেলুন! বিকাশ এবং নগদের মাধ্যমে দ্রুত ডিপোজিট, মোবাইল বোনাস এবং তাৎক্ষণিক টাকা তোলার মাধ্যমে স্লট, ক্র্যাশ গেম এবং স্পোর্টস বেটিং অ্যাক্সেস করুন।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps = (isBN ? descBN : descEN);
      const inLang = isBN ? "bn" : "en";

      const ogImage =
        typeof app1 === "string"
          ? (/^https?:\/\//i.test(app1) ? app1 : `${origin}${app1.startsWith("/") ? "" : "/"}${app1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage (this App page)
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": siteName, "url": origin },
          "primaryImageOfPage": ogImage
        },

        // Organization (with description as requested)
       {
         "@context": "https://schema.org",
         "@type": "Organization",
         "name": siteName,
         "url": origin,
         "description": pageDescCaps,
         "logo": {app1}, 
         "address": {
           "@type": "PostalAddress",
           "addressCountry": {
             "@type": "Country",
             "name": "BD"
           },
         },
         "contactPoint": [
           {
             "@type": "ContactPoint",
             "contactType": "customer support",
             "email": "support@ze77-bd.com",
             "availableLanguage": ["English", "বাংলা"]
           }
         ],
       
       },

        // MobileApplication (App)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": `${siteName} App`,
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": ogImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          },
          "publisher": {
            "@type": "Organization",
            "name": siteName,
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {/* --- ENGLISH VERSION --- */}
      {lang === "en" && (
  <>
    {/* HERO */}
    <section className="zHHBD-apphero">
      <div className="zHHBD-apphero__bg">
        <div className="zHHBD-apphero__overlay"></div>
        <div className="zHHBD-apphero__glow zHHBD-apphero__glow--1"></div>
        <div className="zHHBD-apphero__glow zHHBD-apphero__glow--2"></div>
      </div>

      <div className="zHHBD-apphero__container">
        <div className="zHHBD-apphero__content">
          <header className="zHHBD-apphero__header">
            <h1 className="zHHBD-apphero__title">
              HHBD App – Casino & Sports in Your Pocket
            </h1>

            <p className="zHHBD-apphero__desc">
              Slip the entire HHBD world into your hand and take it anywhere your day leads.
              Our official iOS and Android application gives you the fastest, most dependable, and most seamless path into your favourite 
              {" "}<Link
                to="/games"
                className="zHHBD-gameshero__link"
                data-discover="true"
              >
                games
              </Link>{" "}
              and the most exciting betting markets. Keep every thrill within reach with the HHBD app—so the action stays one effortless tap away at all times.
            </p>
          </header>

          <div className="zHHBD-apphero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-apphero__btn zHHBD-apphero__btn--main"
              title="Start in minutes with a guided quick-start"
            >
              Get Started on HHBD
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-apphero__btn zHHBD-apphero__btn--ghost"
              title="Direct Android APK download"
            >
              Download APK
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD App — Play your favourite casino titles anytime, anywhere"
        >
          <img
            src={app1}
            loading="eager"
            decoding="async"
            alt="A stylish gentleman checking his phone while neon casino symbols illuminate around him, echoing the HHBD mobile experience."
            title="HHBD App — Play your favourite casino titles anytime, anywhere"
            className=""
          />
        </a>
      </div>
    </section>

    {/* WHY YOU'LL LOVE */}
    <section className="zHHBD-appcards">
      <div className="zHHBD-appcards__bg">
        <div className="zHHBD-appcards__halo zHHBD-appcards__halo--1"></div>
        <div className="zHHBD-appcards__halo zHHBD-appcards__halo--2"></div>
      </div>

      <div className="zHHBD-appcards__container">
        <h2 className="zHHBD-appcards__title">
          Why the HHBD Mobile App Will Win You Over
        </h2>

        <p className="zHHBD-appcards__intro">
          Built for pure speed, sleek polish, and feature depth, the HHBD app outperforms the mobile browser at every turn.
          It’s the fastest route into our universe, with noticeably shorter load times and instant alerts for your 
          {" "}<Link
            to="/bet"
            className="zHHBD-gameshero__link"
            data-discover="true"
          >
            bets
          </Link>{" "}
          and favourite 
          {" "}<Link
            to="/games"
            className="zHHBD-gameshero__link"
            data-discover="true"
          >
            games
          </Link>
          . You’ll also enjoy a hardened environment with the added safety benefits that come with a truly native mobile experience.
        </p>

        <p className="zHHBD-appcards__intro">
          Every tap, swipe, and screen has been refined for clarity and comfort, placing everything you need in one streamlined menu.
          Jump between the 
          {" "}<Link
            to="/casino"
            className="zHHBD-gameshero__link"
            data-discover="true"
          >
            casino
          </Link>{" "}
          and sportsbook, check your profile, or browse thousands of 
          {" "}<Link
            to="/games"
            className="zHHBD-gameshero__link"
            data-discover="true"
          >
            games
          </Link>{" "}
          with a single effortless tap. The compact layout keeps the spotlight on gameplay—not clutter—so your betting stays crisp and focused.
        </p>

        <p className="zHHBD-appcards__intro">
          Installing the HHBD app unlocks exclusive mobile-only 
          {" "}<Link
            to="/bonuses"
            className="zHHBD-gameshero__link"
            data-discover="true"
          >
            bonuses
          </Link>{" "}
          and limited-time promos. These hand-picked rewards are tuned to give app users more mileage—extra fuel for spinning 
          {" "}<Link
            to="/slots"
            className="zHHBD-gameshero__link"
            data-discover="true"
          >
            slots
          </Link>{" "}
          or backing your favourite 
          {" "}<Link
            to="/bet"
            className="zHHBD-gameshero__link"
            data-discover="true"
          >
            sports
          </Link>
          —our way of saying thanks for choosing the native path.
        </p>

        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-appcards__btn"
          title="Open the step-by-step install walkthrough"
        >
          Download APK
        </a>
      </div>
    </section>

    {/* INSTALL / HOW-TO */}
    <section className="zHHBD-appfeatures">
      <div className="zHHBD-appfeatures__bg">
        <div className="zHHBD-appfeatures__beam zHHBD-appfeatures__beam--1"></div>
        <div className="zHHBD-appfeatures__beam zHHBD-appfeatures__beam--2"></div>
      </div>

      <div className="zHHBD-appfeatures__container">
        <div className="zHHBD-appfeatures__col zHHBD-appfeatures__col--left">
          <h2 className="zHHBD-appfeatures__title">
            Installing the HHBD APK on Android
          </h2>
          <p className="zHHBD-appfeatures__text">
            Begin by downloading the official HHBD APK via the button below.
            The app supports Android devices on version 5.0 and newer. At the moment, it’s Android-only and can be installed safely
            outside the Google Play Store using our verified package.
          </p>
        </div>

        <div className="zHHBD-appfeatures__col zHHBD-appfeatures__col--center">
          <figure className="zHHBD-appfeatures__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD App — Mobile play for your favourite casino experiences, anytime"
            >
              <img
                src={app2}
                alt="An elegant Bangladeshi woman in a saree enjoying HHBD Casino on her phone, with coins, cards, and roulette motifs swirling around her."
                title="HHBD App — Mobile play for your favourite casino experiences, anytime"
                className="zHHBD-appfeatures__img"
              />
            </a>
          </figure>
        </div>

        <div className="zHHBD-appfeatures__col zHHBD-appfeatures__col--right">
          <div className="zHHBD-appfeatures__text">
            During installation, Android may display a security prompt that blocks the install.
            That’s normal for apps from new sources. To proceed, open ‘Settings’, go to ‘Security’, and enable ‘Install from Unknown Sources’.
            After switching it on, return to the download and finish the HHBD setup.
          </div>
          <div className="zHHBD-appfeatures__text">
            Once the app is installed, open it and sign in with your existing HHBD credentials—or create a new account right inside the app.
            In moments, you’ll have the full HHBD 
            {" "}<Link
              to="/bet"
              className="zHHBD-gameshero__link"
              data-discover="true"
            >
              betting
            </Link>{" "}
            experience in your hands and ready for action!
          </div>
        </div>
      </div>
    </section>

    {/* WHAT YOU CAN DO */}
    <section className="zHHBD-install-split">
      <div className="zHHBD-install-split__wrapper">
        <div className="zHHBD-install-split__visual">
          <div className="zHHBD-install-split__glow"></div>
          <figure className="zHHBD-install-split__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD App — A bright, fluid gaming flow crafted for players in Bangladesh"
            >
              <img
                src={app3}
                alt="A relaxed Bangladeshi player reclining on a sofa while spinning colourful slot reels in the HHBD app."
                title="HHBD App — A bright, fluid gaming flow crafted for players in Bangladesh"
                className="zHHBD-install-split__img"
              />
            </a>
          </figure>
        </div>

        <div className="zHHBD-install-split__content">
          <h2 className="zHHBD-install-split__title">What Awaits Inside the App?</h2>

          <p className="zHHBD-install-split__help">
            The HHBD app delivers the complete platform with a touch-first interface.
            Glide between 
           {" "} <Link
              to="/casino"
              className="zHHBD-gameshero__link"
              data-discover="true"
            >
              casino
            </Link>{" "}
            <Link
              to="/games"
              className="zHHBD-gameshero__link"
              data-discover="true"
            >
              games
            </Link>
            , live dealer tables, and sports
            {" "}<Link
              to="/bet"
              className="zHHBD-gameshero__link"
              data-discover="true"
            >
              betting
            </Link>{" "}
            markets with intuitive swipes. Manage your account effortlessly and find every feature exactly where you expect it.
          </p>

          <p className="zHHBD-install-split__help">
            Our dedicated sports{" "}
            <Link
              to="/bet"
              className="zHHBD-gameshero__link"
              data-discover="true"
            >
              betting
            </Link>{" "}
            hub is engineered for small screens—track live scores, place pre-match or in-play wagers, and review your slips with navigation designed for quick, confident decisions.
          </p>

          <p className="zHHBD-install-split__help">
            Your preferred payment rails are integrated directly into the app.
            Top up in seconds and withdraw fast without interrupting your session.
            Enjoy smooth, protected transactions through bKash, Nagad, and other trusted providers—keeping your balance safe and your winnings just moments away.
          </p>

          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-install-split__btn"
            title="Download the Android APK now"
          >
            Get the HHBD App
          </a>
        </div>
      </div>
    </section>
  </>







      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
 <>
    {/* HERO */}
    <section className="zHHBD-apphero">
      <div className="zHHBD-apphero__bg">
        <div className="zHHBD-apphero__overlay"></div>
        <div className="zHHBD-apphero__glow zHHBD-apphero__glow--1"></div>
        <div className="zHHBD-apphero__glow zHHBD-apphero__glow--2"></div>
      </div>

      <div className="zHHBD-apphero__container">
        <div className="zHHBD-apphero__content">
          <header className="zHHBD-apphero__header">
            <h1 className="zHHBD-apphero__title">
            HHBD অ্যাপ - আপনার পকেটে ক্যাসিনো এবং খেলাধুলা
            </h1>

            <p className="zHHBD-apphero__desc">
              HHBD-এর পুরো জগতটাকেই হাতে নিন—দিন যেদিকে নিয়ে যায়, সেখানেই খেলুন।
              আমাদের অফিশিয়াল iOS ও Android অ্যাপ আপনাকে সবচেয়ে দ্রুত, নির্ভরযোগ্য ও মসৃণ পথে আপনার প্রিয় 
              {" "}<Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>{" "}
              এবং সবচেয়ে রোমাঞ্চকর বেটিং মার্কেটে পৌঁছে দেয়। HHBD অ্যাপ থাকলে উত্তেজনা থাকে আঙুলের ডগায়—এক ট্যাপেই শুরু হোক অ্যাকশন।
            </p>
          </header>

          <div className="zHHBD-apphero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-apphero__btn zHHBD-apphero__btn--main"
              title="কয়েক মিনিটেই নির্দেশনা মেনে শুরু করুন"
            >
              HHBD-এ শুরু করুন
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-apphero__btn zHHBD-apphero__btn--ghost"
              title="অ্যান্ড্রয়েড APK সরাসরি ডাউনলোড"
            >
              APK ডাউনলোড করুন
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD অ্যাপ — যেকোনো সময়, যেকোনো স্থানে আপনার প্রিয় ক্যাসিনো টাইটেল খেলুন"
        >
          <img
            src={app1}
            loading="eager"
            decoding="async"
            alt="স্টাইলিশ এক ভদ্রলোক ফোনে তাকিয়ে আছেন; চারপাশে নীয়ন ক্যাসিনো আইকন—HHBD মোবাইল অ্যাপের অনুভূতি।"
            title="HHBD অ্যাপ — যেকোনো সময়, যেকোনো স্থানে আপনার প্রিয় ক্যাসিনো টাইটেল খেলুন"
            className=""
          />
        </a>
      </div>
    </section>

    {/* WHY YOU'LL LOVE */}
    <section className="zHHBD-appcards">
      <div className="zHHBD-appcards__bg">
        <div className="zHHBD-appcards__halo zHHBD-appcards__halo--1"></div>
        <div className="zHHBD-appcards__halo zHHBD-appcards__halo--2"></div>
      </div>

      <div className="zHHBD-appcards__container">
        <h2 className="zHHBD-appcards__title">
          কেন HHBD মোবাইল অ্যাপ আপনাকে মুগ্ধ করবে
        </h2>

        <p className="zHHBD-appcards__intro">
          খাঁটি গতি, মসৃণ নকশা এবং সমৃদ্ধ ফিচারের জন্য বানানো—HHBD অ্যাপ প্রতিটি ক্ষেত্রেই মোবাইল ব্রাউজারকে ছাড়িয়ে যায়।
          আমাদের জগতে ঢোকার এটি সবচেয়ে দ্রুত পথ—স্পষ্টত দ্রুত লোড টাইম এবং আপনার {" "}
          <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">বেটিং</Link>{" "}
          ও পছন্দের {" "}
          <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>{" "}
          সংক্রান্ত তাৎক্ষণিক অ্যালার্টসহ। নেটিভ মোবাইল অভিজ্ঞতার নিরাপত্তা সুবিধাও এখানে পাবেন—আরও শক্ত দেয়াল, আরও নিশ্চিন্ত খেলা।
        </p>

        <p className="zHHBD-appcards__intro">
          প্রতিটি ট্যাপ, সুইপ ও স্ক্রিনকে স্বচ্ছতা ও আরামের জন্য শান দেওয়া হয়েছে—আপনার দরকারি সবকিছু এক সুশৃঙ্খল মেনুতেই।
          এক ট্যাপে
         {" "} <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link>{" "}
          ও স্পোর্টসবুকের মাঝে চলুন, প্রোফাইল দেখুন, বা হাজারো 
         {" "} <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>{" "}
          ব্রাউজ করুন। কমপ্যাক্ট লেআউট খেলার ওপর ফোকাস রাখে—অযথা ভিড় নয়—তাই বেটিং থাকে ধারালো ও নির্ভুল।
        </p>

        <p className="zHHBD-appcards__intro">
          HHBD অ্যাপ ইনস্টল করলে আনলক হবে এক্সক্লুসিভ মোবাইল-অনলি {" "}
          <Link to={getLangPath("/bonuses", lang)} className="rr555-aviatorlux__link">বোনাস</Link>{" "}
          এবং সীমিত সময়ের প্রোমো। এগুলো অ্যাপ ব্যবহারকারীদের জন্য বিশেষভাবে টিউন করা—যাতে {" "}
          <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link>{" "}
          ঘোরানো বা প্রিয় {" "}
          <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">স্পোর্টস</Link>{" "}
          সমর্থনে বাড়তি শক্তি পান। নেটিভ অভিজ্ঞতা বেছে নেওয়ার জন্য এটি আমাদের কৃতজ্ঞতা।
        </p>

        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-appcards__btn"
          title="ধাপে ধাপে ইনস্টল গাইড খুলুন"
        >
          APK ডাউনলোড করুন
        </a>
      </div>
    </section>

    {/* INSTALL / HOW-TO */}
    <section className="zHHBD-appfeatures">
      <div className="zHHBD-appfeatures__bg">
        <div className="zHHBD-appfeatures__beam zHHBD-appfeatures__beam--1"></div>
        <div className="zHHBD-appfeatures__beam zHHBD-appfeatures__beam--2"></div>
      </div>

      <div className="zHHBD-appfeatures__container">
        <div className="zHHBD-appfeatures__col zHHBD-appfeatures__col--left">
          <h2 className="zHHBD-appfeatures__title">
            অ্যান্ড্রয়েডে HHBD APK কীভাবে ইনস্টল করবেন
          </h2>
          <p className="zHHBD-appfeatures__text">
            নিচের বোতাম থেকে অফিশিয়াল HHBD APK ডাউনলোড দিয়ে শুরু করুন।
            অ্যাপটি Android 5.0 বা তার পরের ভার্সন সমর্থন করে। আপাতত এটি অ্যান্ড্রয়েড-অনলি এবং
            আমাদের ভেরিফায়েড প্যাকেজ দিয়ে Google Play Store-এর বাইরে থেকেও নিরাপদে ইনস্টল করা যায়।
          </p>
        </div>

        <div className="zHHBD-appfeatures__col zHHBD-appfeatures__col--center">
          <figure className="zHHBD-appfeatures__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD অ্যাপ — যেকোনো সময় আপনার প্রিয় ক্যাসিনো অভিজ্ঞতা মোবাইলে"
            >
              <img
                src={app2}
                alt="শাড়ি-পরা এক আভিজাত্যশালী বাঙালি নারী ফোনে HHBD ক্যাসিনো উপভোগ করছেন; চারপাশে কয়েন, কার্ড ও রুলেট মোটিফ।"
                title="HHBD অ্যাপ — যেকোনো সময় আপনার প্রিয় ক্যাসিনো অভিজ্ঞতা মোবাইলে"
                className="zHHBD-appfeatures__img"
              />
            </a>
          </figure>
        </div>

        <div className="zHHBD-appfeatures__col zHHBD-appfeatures__col--right">
          <div className="zHHBD-appfeatures__text">
            ইনস্টলের সময় অ্যান্ড্রয়েড একটি সিকিউরিটি প্রম্পট দেখিয়ে ব্লক করতে পারে—নতুন সোর্সের অ্যাপের ক্ষেত্রে এটি স্বাভাবিক।
            সমাধান: ‘Settings’ খুলে ‘Security’-এ যান এবং ‘Install from Unknown Sources’ চালু করুন।
            এরপর ডাউনলোড পেইজে ফিরে এসে HHBD সেটআপ সম্পন্ন করুন।
          </div>
          <div className="zHHBD-appfeatures__text">
            ইনস্টল শেষ হলে অ্যাপ চালু করে আপনার বিদ্যমান HHBD ক্রেডেনশিয়াল দিয়ে সাইন ইন করুন—অথবা অ্যাপ থেকেই নতুন অ্যাকাউন্ট তৈরি করুন।
            কয়েক মুহূর্তেই আপনার হাতে পুরো HHBD {" "}
            <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">বেটিং</Link>{" "}
            অভিজ্ঞতা—খেলার জন্য প্রস্তুত!
          </div>
        </div>
      </div>
    </section>

    {/* WHAT YOU CAN DO */}
    <section className="zHHBD-install-split">
      <div className="zHHBD-install-split__wrapper">
        <div className="zHHBD-install-split__visual">
          <div className="zHHBD-install-split__glow"></div>
          <figure className="zHHBD-install-split__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD অ্যাপ — বাংলাদেশি প্লেয়ারদের জন্য উজ্জ্বল, তরল গেমিং ফ্লো"
            >
              <img
                src={app3}
                alt="সোফায় হেলান দিয়ে আরাম করে HHBD অ্যাপে রঙিন স্লট রিল ঘুরাচ্ছেন এক বাংলাদেশি প্লেয়ার।"
                title="HHBD অ্যাপ — বাংলাদেশি প্লেয়ারদের জন্য উজ্জ্বল, তরল গেমিং ফ্লো"
                className="zHHBD-install-split__img"
              />
            </a>
          </figure>
        </div>

        <div className="zHHBD-install-split__content">
          <h2 className="zHHBD-install-split__title">অ্যাপের ভেতরে কী থাকছে?</h2>

          <p className="zHHBD-install-split__help">
            HHBD অ্যাপ টাচ-ফার্স্ট ইন্টারফেসসহ পুরো প্ল্যাটফর্ম আপনার হাতে তুলে দেয়।
            সহজ সোয়াইপে চলুন {" "}
            <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link>{" "}
            <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>
            , লাইভ ডিলার টেবিল এবং স্পোর্টস{" "}
            <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">বেটিং</Link>{" "}
            মার্কেটের মাঝে—অ্যাকাউন্ট ম্যানেজ করুন অনায়াসে; প্রতিটি ফিচার মিলবে প্রত্যাশিত জায়গাতেই।
          </p>

          <p className="zHHBD-install-split__help">
            আমাদের ডেডিকেটেড স্পোর্টস{" "}
            <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">বেটিং</Link>{" "}
            হাব ছোট স্ক্রিনের জন্য বিশেষভাবে তৈরি—লাইভ স্কোর দেখুন, প্রি-ম্যাচ বা ইন-প্লে বেট করুন, আর আপনার স্লিপ হিস্ট্রি দেখুন—সবকিছু দ্রুত, আত্মবিশ্বাসী সিদ্ধান্তের উপযোগী নেভিগেশনে।
          </p>

          <p className="zHHBD-install-split__help">
            আপনার পছন্দের পেমেন্ট রেইলগুলো অ্যাপের ভেতরেই ইন্টিগ্রেটেড।
            কয়েক সেকেন্ডে টপ-আপ করুন এবং বিরতি ছাড়াই দ্রুত উইথড্র নিন।
            bKash, Nagad এবং অন্যান্য বিশ্বস্ত প্রোভাইডারের মাধ্যমে স্মুথ ও সুরক্ষিত লেনদেন—ব্যালান্স থাকবে নিরাপদ, জেতা অর্থ থাকবে হাতের নাগালে।
          </p>

          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-install-split__btn"
            title="এখনই অ্যান্ড্রয়েড APK ডাউনলোড করুন"
          >
            HHBD অ্যাপ নিন
          </a>
        </div>
      </div>
    </section>
  </>




      )}
    </>
  );
};

export default Application;
